import React from 'react';

import { EmployerStaffWrapperEMPAdmin } from 'src/components/employer';
import { EmployerStaffDetailsModal } from 'src/modals/employer';
import { EmployerStaffInviteModal } from 'src/modals/employerStaff';
import { ResendInviteModal } from 'src/modals/invite';
import { TableDataProvider } from 'src/providers/TableDataProvider';

export const EmployerStaffPageEMPAdmin: React.FC = () => {
  return (
    <TableDataProvider>
      <EmployerStaffWrapperEMPAdmin />
      <EmployerStaffDetailsModal />
      <EmployerStaffInviteModal />
      <ResendInviteModal />
    </TableDataProvider>
  );
};
